import React from 'react';
import Form from '../Form';
import RegisteredIcon from '../RegisteredIcon';

/**
 * Form component for editing an existing social link
 */
export default function EditSocialForm({ social, onSave, onCancel, loading }) {
    if (!social) return null;
    const [url, setUrl] = React.useState(social.url);

    const fields = [
        {
            name: 'url',
            type: 'url',
            label: `${social.platform.icon ? '' : '🔗 '}URL`,
            placeholder: `Enter your ${social.platform.label} URL`,
            required: true,
            help: social.platform.prefix ? 
                `Prefix "${social.platform.prefix}" will be added automatically if needed.` : 
                undefined
        }
    ];

    const handleSubmit = (values) => {
        if (onSave) {
            onSave({ ...social, url: values.url });
        }
    };

    const handleChange = (newValues) => {
        setUrl(newValues.url);
    }

    return (
        <div className="edit-social-form">
            <h4>
                {social.platform.icon && <RegisteredIcon value={social.platform.icon} />} Edit{' '}
                {social.platform.label}
            </h4>
            <Form
                fields={fields}
                values={{ url: url }}
                onSubmit={handleSubmit}
                onChange={handleChange}
            >
                <div className="group">
                    <button 
                        type="submit"
                        disabled={loading}
                        className="btn btn-primary"
                    >
                        {loading ? 'Saving...' : 'Save'}
                    </button>
                    <button 
                        type="button" 
                        onClick={onCancel}
                        className="btn secondary"
                    >
                        Cancel
                    </button>
                </div>
            </Form>
        </div>
    );
}
